import { isEmpty, isEqual } from 'app/commons/helpers/compare'
import { hideLoading, showLoading } from 'app/commons/helpers/loadingUtils'
import * as Utils from 'app/commons/helpers/utils'
import * as authAction from 'app/store/auth/authAction'
import { modalCreateActions } from 'app/store/modal/modalSlice'
import { getAndCheckTokenCaptCha } from 'app/utils/authentication'
import { Formik } from 'formik'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import * as Yup from 'yup'

import React, { Component } from 'react'
import { withGoogleReCaptcha } from 'react-google-recaptcha-v3'
import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { toast } from 'react-toastify'
import { Row } from 'reactstrap'

import _get from 'lodash.get'

import ButtonSocial from 'app/components/Common/ButtonSocial'

import { LOCAL_STORAGE } from '../../commons/constants/index'
import { MODAL_TYPES } from '../../commons/constants/modal.const'
import { validatePhoneNumberWithCountry } from '../../commons/helpers/index'
import InputPhone from '../InputPhone/index'
import './style.scss'

let INIT_VALUES = {
  first_name: '',
  last_name: '',
  phone: '',
  email: '',
  password: '',
  country_code: 'id',
  referral_code: null,
  business_name: null,
}

Yup.addMethod(Yup.string, 'phoneValidate', (message, countryCode) =>
  Yup.string()
    .required('signup.phoneRequired')
    .test('phoneValidate', message, (value) => {
      if (value) {
        return validatePhoneNumberWithCountry(value, countryCode)
      }
      return value
    })
)

const SignupSchema = Yup.object().shape({
  first_name: Yup.string().required('signup.firstNameRequired').trim('signup.firstNameRequired'),
  last_name: Yup.string().required('signup.lastNameRequired').trim('signup.lastNameRequired'),
  phone: Yup.string().phoneValidate('signup.phoneInvalid', INIT_VALUES.country_code),
  email: Yup.string().required('signup.emailRequired').email('signup.emailInvalid'),
  password: Yup.string().required('signup.passwordRequired').min(6, 'signup.passwordInvalid'),
})

class Signup extends Component {
  inputPhone = null

  static renderTextError(error, textError, text) {
    if (error) {
      return [<i className="material-icons mr5 Icon b">error</i>, textError]
    }
    return text
  }

  constructor() {
    super()
    this.state = {
      showPassword: false,
      countryDialCode: '84',
      isFocus: false,
    }
    const signupDataLocal = localStorage.getItem(LOCAL_STORAGE.SIGNUP_INFORMATION_LOCAL)
    if (signupDataLocal) {
      INIT_VALUES = JSON.parse(signupDataLocal)
    }
    this.myRef = React.createRef()
  }

  componentDidMount() {
    const defaultCountry = localStorage.getItem(LOCAL_STORAGE.DEFAULT_COUNTRY) || 'id'
    SignupSchema.fields.phone = Yup.string().phoneValidate('signup.phoneInvalid', defaultCountry)
  }

  componentDidUpdate(prevProps) {
    const { initialValues: prevInitialValues } = prevProps
    const { initialValues } = this.props
    if (!isEqual(prevInitialValues, initialValues) && !isEmpty(initialValues) && this.myRef) {
      const currentRef = this.myRef.current
      const { email, firstName, lastName } = initialValues
      const { values } = currentRef
      const newValue = {
        ...values,
        email,
        first_name: firstName,
        last_name: lastName,
      }
      currentRef.setValues(newValue)
    }
  }

  getInitialValue() {
    const { initialValues } = this.props
    if (!isEmpty(initialValues)) {
      const { email, firstName, lastName } = initialValues
      return {
        ...INIT_VALUES,
        email,
        first_name: firstName,
        last_name: lastName,
      }
    }
    return INIT_VALUES
  }

  onCountryCodeValueChanged(country) {
    const phoneValidateObject = Yup.string().phoneValidate('signup.phoneInvalid', country.iso2)
    this.setState({
      countryDialCode: country.dialCode,
    })
    SignupSchema.fields.phone = phoneValidateObject
  }

  onPhoneNumberInputBlur(props) {
    props.setFieldTouched('phone', true)
  }

  onClickSignup = (values) => {
    this.signUp(values)
  }

  onClickClosePopupButton() {
    const { actions } = this.props
    actions.closeModal()
  }

  onClickLogin() {
    const { actions } = this.props
    actions.openModal({ typeModal: MODAL_TYPES.LOGIN })
  }

  changeTypeInput = (conditonChangeTypeInput) => (conditonChangeTypeInput ? 'input' : 'password')

  signUp = async (values) => {
    showLoading()
    const { actions, googleReCaptchaProps, enableCaptchaVerification } = this.props
    values.first_name = values.first_name ? values.first_name.trim() : values.first_name
    values.last_name = values.last_name ? values.last_name.trim() : values.last_name
    values.email = values.email ? values.email.toLowerCase() : values.email
    localStorage.getItem(LOCAL_STORAGE.SIGNUP_INFORMATION_LOCAL, JSON.stringify(values))

    const onSignUpSuccess = (dataResult) => {
      localStorage.removeItem(LOCAL_STORAGE.SIGNUP_INFORMATION_LOCAL)
      actions.closeModal()
      actions.handleGetAuth({ accountId: dataResult.id, callbackAfterGetAuth: hideLoading() })
    }
    const onSignUpError = (message) => {
      hideLoading()
      toast.error(message)
    }
    const executeRecaptcha = googleReCaptchaProps?.executeRecaptcha
    let xRecaptchaToken
    if (enableCaptchaVerification) {
      xRecaptchaToken = await getAndCheckTokenCaptCha(executeRecaptcha, 'signup')
    }
    actions.postSignUp({ dataInfo: values, onSignUpSuccess, onSignUpError, xRecaptchaToken })
  }

  showPassword = (conditionShowPassword) => (conditionShowPassword ? 'green' : 'gray')

  toggleShowPassword() {
    const { showPassword } = this.state
    this.setState({ showPassword: !showPassword })
  }

  render() {
    const { showPassword } = this.state
    const error = false
    const { t, actions, data } = this.props
    const passwordClass = this.showPassword(showPassword)
    const tcLink = _get(data, 'tc_link.non_bp', '')
    const privatePolicyURL = _get(data, 'privacy_policy_link', '')
    const defaultCountry = localStorage.getItem(LOCAL_STORAGE.DEFAULT_COUNTRY) || 'id'
    return (
      <>
        <Formik
          initialValues={this.getInitialValue()}
          validationSchema={SignupSchema}
          onSubmit={(values, { setSubmitting }) => {
            this.onClickSignup(values)
            setSubmitting(false)
          }}
          innerRef={this.myRef}
        >
          {(props) => (
            <div className="popup-auth">
              <div className="auth-body signup">
                <div className="auth-close">
                  <i onClick={() => actions.closeModal()} className="material-icons" role="presentation">
                    close
                  </i>
                </div>
                <div className="signup-header">
                  {t('signup.alreadyHaveAccount', { app_name: Utils.appName() })}{' '}
                  <div
                    className="Link-Button"
                    onClick={() => {
                      this.onClickLogin()
                    }}
                    role="presentation"
                  >
                    {t('signup.logInHere')}
                  </div>
                </div>
                <div className="signup-container">
                  <form className="Form-Container" onSubmit={props.handleSubmit}>
                    <Row>
                      <div className={`form-group col-md-6 ${props.touched.email && props.errors.email && 'error'}`}>
                        <label className="form-label">{t('signup.emailLabel')}</label>
                        <div className="input-group">
                          <input
                            className="form-control"
                            id="email"
                            name="email"
                            value={props.values.email}
                            onChange={props.handleChange}
                            onBlur={props.handleBlur}
                          />
                        </div>
                        {props.touched.email && props.errors.email && (
                          <div className="error__message">{t(props.errors.email)}</div>
                        )}
                      </div>
                      <div className={`form-group col-md-6 ${props.touched.phone && props.errors.phone && 'error'}`}>
                        <label className="form-label">{t('signup.mobilePhone')}</label>
                        <div className="input-group">
                          <InputPhone
                            type="text"
                            name="phone"
                            id="phone"
                            ref={(inputPhone) => {
                              this.inputPhone = inputPhone
                            }}
                            defaultCountryValue={defaultCountry}
                            value={props.values.phone}
                            onChange={(value) => {
                              props.setFieldValue('phone', value)
                            }}
                            onCountryCodeValueChanged={(country) => {
                              props.setFieldValue('country_code', country.iso2)
                              this.onCountryCodeValueChanged(country)
                            }}
                            onPhoneNumberBlur={() => {
                              props.setFieldTouched('phone', true)
                              this.onPhoneNumberInputBlur(props)
                            }}
                            placeholder=""
                          />
                        </div>
                        {props.touched.phone && props.errors.phone && (
                          <div className="error__message">{t(props.errors.phone)}</div>
                        )}
                      </div>
                    </Row>
                    <Row>
                      <div
                        className={`form-group col-md-6 ${
                          props.touched.first_name && props.errors.first_name && 'error'
                        }`}
                      >
                        <label className="form-label">{t('signup.firstNameLabel')}</label>
                        <div className="input-group">
                          <input
                            className="form-control"
                            name="first_name"
                            id="first_name"
                            value={props.values.first_name}
                            onChange={props.handleChange}
                            onBlur={props.handleBlur}
                          />
                        </div>
                        {props.touched.first_name && props.errors.first_name && (
                          <div className="error__message">{t(props.errors.first_name)}</div>
                        )}
                      </div>
                      <div
                        className={`form-group col-md-6 ${
                          props.touched.last_name && props.errors.last_name && 'error'
                        }`}
                      >
                        <label className="form-label">{t('signup.lastNameLabel')}</label>
                        <div className="input-group">
                          <input
                            className="form-control"
                            id="last_name"
                            placeholder=""
                            name="last_name"
                            value={props.values.last_name}
                            onChange={props.handleChange}
                            onBlur={props.handleBlur}
                          />
                        </div>
                        {props.touched.last_name && props.errors.last_name && (
                          <div className="error__message">{t(props.errors.last_name)}</div>
                        )}
                      </div>
                    </Row>
                    <Row>
                      <div className={`form-group col-md-6 ${error && 'error'}`}>
                        <label className="form-label">{t('signup.businessNameLabel')}</label>
                        <div className="input-group">
                          <input
                            className="form-control"
                            id="business_name"
                            name="business_name"
                            value={props.values.business_name ? props.values.business_name : ''}
                            onChange={props.handleChange}
                            onBlur={props.handleBlur}
                          />
                        </div>
                      </div>
                      <div className={`form-group col-md-6 ${error && 'error'}`}>
                        <label className="form-label">{t('signup.referralCodeLabel')}</label>
                        <input
                          className="form-control"
                          id="referral_code"
                          name="referral_code"
                          value={props.values.referral_code ? props.values.referral_code : ''}
                          onChange={props.handleChange}
                          onBlur={props.handleBlur}
                        />
                      </div>
                    </Row>
                    <Row>
                      <div
                        className={`form-group col-md-12 ${props.touched.password && props.errors.password && 'error'}`}
                      >
                        <label className="form-label">{t('signup.passwordLabel')}</label>
                        <div className="input-group">
                          <input
                            type={this.changeTypeInput(showPassword)}
                            className="form-control no-border-right"
                            id="password"
                            name="password"
                            value={props.values.password}
                            onChange={props.handleChange}
                            onBlur={props.handleBlur}
                          />
                          <div className="input-group-text">
                            <i
                              onClick={() => {
                                this.toggleShowPassword()
                              }}
                              role="presentation"
                              className={`material-icons Icon xb cur-pointer ${passwordClass}`}
                            >
                              visibility
                            </i>
                          </div>
                        </div>
                        {props.touched.password && props.errors.password && (
                          <div className="error__message">{t(props.errors.password)}</div>
                        )}
                      </div>
                    </Row>
                    <div className="signup-form--submit text-center">
                      <button type="submit" className="Button h36 green w-100">
                        {t('signup.singupButton')}
                      </button>
                    </div>
                    <div
                      className="signup-form--footer"
                      dangerouslySetInnerHTML={{
                        __html: t('signup.byClicking', {
                          term_link: tcLink,
                          privacy_link: privatePolicyURL,
                          app_name: Utils.appName(),
                        }),
                      }}
                    />
                    <div class="Box-Content-Social-Line">
                      <h5>{t('signup.orSignUpWith')}</h5>
                      <div class="line"></div>
                    </div>
                    <ButtonSocial />
                  </form>
                </div>
              </div>
            </div>
          )}
        </Formik>
      </>
    )
  }
}
const mapStateToProps = (state) => ({
  data: _get(state, 'configuration.data'),
  enableCaptchaVerification: state.configuration?.data?.enable_captcha_verification,
})

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators({ ...modalCreateActions, ...authAction }, dispatch),
})

Signup.propTypes = {
  actions: PropTypes.objectOf(PropTypes.func).isRequired,
}

Signup.defaultProps = {}

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(withGoogleReCaptcha(Signup)))
